export default {
  title: 'Cum funcționează comisioanele de procesare',
  how_it_works:
    'Stripe percepe platformei tale comisionul său la fiecare plată online primită de restaurantele tale. Comisionul de procesare pe care îl stabilești este suma pe care restaurantul o plătește pentru acea plată. Dacă este mai mare decât comisionul Stripe, diferența rămâne la tine ca marjă. Dacă este mai mic sau nu stabilești niciunul, diferența o plătești tu.',
  stripe_rates_link: 'Vezi tarifele standard Stripe',
  example: {
    intro:
      'Exemplu: o comandă de {{total}} plătită cu cardul. Stripe percepe platformei tale {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Tariful tău {{rate}}: restaurantul plătește {{fee}}, tu păstrezi {{difference}}.',
    below: 'Tariful tău {{rate}}: restaurantul plătește {{fee}}, tu plătești diferența de {{difference}}.',
    none: 'Fără tarif (marjă 0%): restaurantul nu plătește nimic, tu plătești integral {{stripe_fee}}.',
    disclaimer:
      'Comisionul Stripe de aici este tariful său standard pentru carduri în SEE, cu titlu de exemplu. Comisionul real depinde de card, de țara acestuia și de prețurile tale Stripe.',
  },
};
